import React from "react";
import "../SectionThirteen.css";

const Card = ({ imgUrl, title }) => {
  return (
    <div className="sectionThirteen_card">
      <div className="sectionThirteen_card_top">
        <img src={imgUrl} className="sectionThirteen_card_top_image" alt="" />
      </div>
      <div className="sectionThirteen_card_bottom">
        <span className="sectionThirteen_card_bottom_title">{title}</span>
      </div>
    </div>
  );
};

export default Card;
